import { createVNode as _createVNode } from "vue";
/**
 * @author zhouchangluan
 * @fileoverview 首页 - 路由页面
 */
import { defineComponent } from "vue";
// components
import PcBox from "./pc/index.vue";
import MBox from "./m/index.vue";
export default defineComponent({
  name: "HomePage",
  setup() {
    return () => {
      return window.screen.width < 1200 ? _createVNode(MBox, null, null) : _createVNode(PcBox, null, null);
    };
  }
});